const ValidationMap = {
	email: {
		required: '이메일은 필수 입력입니다.',
		maxLength: {
			value: 254,
			message: '올바른 이메일 형식을 입력해주세요.',
		},
		pattern: {
			value: /^(?!.*\.\.)(?!\.)(?!.*\.$)[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/,
			message: '올바른 이메일 형식을 입력해주세요.',
		},
	},
	password: {
		required: '비밀번호는 필수 입력입니다.',
		pattern: {
			value: /^(?=.*[A-Za-z])(?=.*\d)[^\s]{10,16}$/,
			message: '영문, 숫자 등이 포함된 10~16자 비밀번호를 입력해 주세요.',
		},
	},
	english: {
		required: '영문 이름은 필수 입력입니다.',
		pattern: {
			value: /^[A-Za-z\s]+$/,
			message: '영문자만 입력 가능합니다.',
		},
	},
	required: {
		required: '필수 입력입니다.',
	},
	optional: {}, // 선택 항목은 검증 없음
}

export default ValidationMap
